import { jsx as e, jsxs as o } from "react/jsx-runtime";
import { Drawer as x, DrawerOverlay as g, DrawerContent as l } from "@chakra-ui/react";
import { InlineDrawer as b } from "./inline-drawer.js";
function y({
  children: a,
  isOpen: f,
  onClose: u,
  isInline: w = !1,
  closeOnEsc: m = !0,
  closeOnOverlayClick: D = !0,
  autoFocus: n = !0,
  placement: i = "right",
  size: r = "xs",
  ...t
}) {
  return w && r !== "full" ? /* @__PURE__ */ e(b, { isOpen: f, onClose: u, size: r, closeOnEsc: m, ...t, children: a }) : /* @__PURE__ */ o(
    x,
    {
      isOpen: f,
      autoFocus: n,
      onClose: u,
      placement: i,
      closeOnEsc: m,
      closeOnOverlayClick: D,
      size: r,
      ...t,
      children: [
        /* @__PURE__ */ e(g, { bg: "rgba(0, 0, 0, 0.32)" }),
        /* @__PURE__ */ e(l, { ...t, children: a })
      ]
    }
  );
}
export {
  y as Drawer
};
